import request from '@utils/request'

export const state = {
  list: [],
  userSelectShippingPoint: ''
}

export const getters = {
  inventoryListLength(){
    return state.list.length
  }
}

export const mutations = {
  PUSH_LIST(state, newValue) {
    if (state.list.length === 0) {
      state.list.push(...newValue)
    }
    if (state.list.length > 0) {
      const idsMap = state.list.map(item => item.id)
      newValue.forEach(item => {
        if (!idsMap.includes(item.id)) {
          state.list.push(item);
          idsMap.push(item.id); // 更新 idsMap
        }
      });
    }
  },
  TO_EMPTY_LIST(state, newValue) {
    state.list = []
  },
  DELETE_ITEM(state, newValue) {
    state.list = state.list.filter(item => item.id !== newValue.id)
  },
  USER_SELECT_SHIPPING_POINT(state, newValue) {
    console.log(newValue)
    state.userSelectShippingPoint = newValue
    console.log("🚀 ~ file: inventory.js:38 ~ USER_SELECT_SHIPPING_POINT ~ state.userSelectShippingPoint:", state.userSelectShippingPoint)
    
  },
  CLEAR_SELECT_SHIPPING_POINT(state, newValue) {
    state.userSelectShippingPoint = ''
    console.log("🚀 ~ file: inventory.js:43 ~ CLEAR_SELECT_SHIPPING_POINT ~ state.userSelectShippingPoint:", state.userSelectShippingPoint)
  },
}

export const actions = {
  getItemByNo({ commit }, { productId, no }) {
    return request.post(`/admin/service/servicePetSize/getItemByNo`, {
      product_id: productId,
      no,
    })
  },
  updateState({ commit }, { productId, groupId, ids = [], state }) {
    return request.post(`/admin/product/${productId}/group/${groupId}/inventory/state`, {
      ids,
      state,
    })
  },
  /**
   * @description 取得庫存歷史細節
   */
  inventoryHistoryDetail({ commit }, { id }) {
    return request.get(`admin/service/inventory/history/${id}`).then((response) => {
      return response
    })
  },

  remove({ commit }, { productId, groupId, ids = [] }) {
    return request.post(`/admin/product/${productId}/group/${groupId}/inventory/remove`, {
      ids,
    })
  },
  store({ commit }, { productId, groupId, storeData }) {
    return request.post(`/admin/product/${productId}/group/${groupId}/inventory/store`, storeData)
  },
  fetchList({ commit }, { productId, groupId, query }) {
    return request.post(`/admin/product/${productId}/group/${groupId}/inventory/search`, query).then(({ items, pagination: { total } }) => {
      return {
        items,
        total,
      }
    })
  },
  updateGroupState({ commit }, { productId, ids = [], state }) {
    return request.post(`/admin/product/${productId}/group/stateInventories`, {
      ids,
      state,
    })
  },
  removeGroups({ commit }, { productId, ids = [] }) {
    return request.post(`/admin/product/${productId}/group/remove`, {
      ids,
    })
  },
  storeGroups({ commit }, { productId, submitData }) {
    return request.post(`/admin/product/${productId}/group/store`, {
      groups: submitData,
    })
  },
  fetchGroups({ commit }, { productId, query }) {
    return request.post(`/admin/product/${productId}/group/search`, query).then(({ items, pagination: { total } }) => {
      return {
        items,
        total,
      }
    })
  },
  /**
   * @description 進貨or出貨的api
   * @returns 
   */
  addSubStore({ commit }, submitData) {
    return request.post(`admin/service/inventory/add`, submitData)
  }
}
